module.exports = __webpack_public_path__ + "static/media/stop-gender-violence.c6fb1bbd.svg";